var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlockOutlineIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0003 1.6665C5.40033 1.6665 1.66699 5.39984 1.66699 9.99984C1.66699 14.5998 5.40033 18.3332 10.0003 18.3332C14.6003 18.3332 18.3337 14.5998 18.3337 9.99984C18.3337 5.39984 14.6003 1.6665 10.0003 1.6665ZM3.33366 9.99984C3.33366 6.3165 6.31699 3.33317 10.0003 3.33317C11.542 3.33317 12.9587 3.85817 14.0837 4.7415L4.74199 14.0832C3.8268 12.9191 3.33065 11.4806 3.33366 9.99984ZM10.0003 16.6665C8.45866 16.6665 7.04199 16.1415 5.91699 15.2582L15.2587 5.9165C16.1739 7.08056 16.67 8.5191 16.667 9.99984C16.667 13.6832 13.6837 16.6665 10.0003 16.6665Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlockOutlineIcon);
export default __webpack_public_path__ + "static/media/block-outline-icon.2f3cd5cd1593eedc930c8d9276a7f6bd.svg";
export { ForwardRef as ReactComponent };